import React, {useEffect} from 'react'
import './footer.css'
import video from '../../Assets/video(2).mp4'

import Aos from 'aos'
import 'aos/dist/aos.css'

import {FiSend} from 'react-icons/fi'
import {MdTravelExplore} from 'react-icons/md'
import {AiOutlineTwitter} from 'react-icons/ai'
import {AiFillYoutube} from 'react-icons/ai'
import {AiFillInstagram} from 'react-icons/ai'
import {FiChevronRight} from 'react-icons/fi'
import {FaRegCopyright} from 'react-icons/fa'
import {BsFacebook} from 'react-icons/bs'
import {FaTiktok} from 'react-icons/fa'

const Footer = () => {

  useEffect(()=>{
    Aos.init({duration: 2000})
  },[])

  return (
    <section className="footer">
      <div className="videoDiv">
        <video src={video} loop autoPlay muted type="video/mp4"></video>
      </div>

      <div className="secContent container">
        <div className="contactDiv flex">
          <div data-aos="fade-up" className="text">
            <small>KEEP IN TOUCH</small>
            <h2>Travel with us</h2>
          </div>

          <div data-aos="fade-up" className="inputDiv fle">
            <input type="text" placeholder='Enter Email Address' />
            <button className="btn flex" type='submit'>
              SEND <FiSend className="icon"/>
            </button>
          </div>
        </div>

        <div data-aos="fade-up" className="footerCard flex">
          <div className="footerIntro flex">
            <div className="logoDiv">
              <a href="#" className='logo flex'>
              <MdTravelExplore className='icon'/> Desa Nusantara</a>
            </div>

            <div className="footerParagraph">
              Lorem ipsum dolor sit amet consectetur, adipisicing elit. Mollitia repudiandae autem in a dolor, natus, quasi enim debitis veniam similique consequatur officia? Nemo, quo hic.
            </div>

            <div className="footerSocials">
              <AiOutlineTwitter className='icon'/>
              <AiFillYoutube className='icon'/>
              <AiFillInstagram className='icon'/>
              <BsFacebook className='icon'/>
              <FaTiktok className='icon'/>
            </div>
          </div>

          <div className="footerLinks grid">

            {/* one */}
            <div className="linkGroup">
              <span className="groupTitle">
              About Desa Nusantara
              </span>

              <li className="footerList flex">
                <FiChevronRight className='icon'/> About Us
              </li>

              <li className="footerList flex">
                <FiChevronRight className='icon'/> How to Book
              </li>

              <li className="footerList flex">
                <FiChevronRight className='icon'/> Contact Us
              </li>

              <li className="footerList flex">
                <FiChevronRight className='icon'/> Help Center
              </li>

            </div>

            {/* Two */}
            <div className="linkGroup">
              <span className="groupTitle">
                Products
              </span>

              <li className="footerList flex">
                <FiChevronRight className='icon'/> Flights
              </li>

              <li className="footerList flex">
                <FiChevronRight className='icon'/> Hotels
              </li>

              <li className="footerList flex">
                <FiChevronRight className='icon'/> Trains
              </li>

              <li className="footerList flex">
                <FiChevronRight className='icon'/> Car rental
              </li>
              
              <li className="footerList flex">
                <FiChevronRight className='icon'/> Bus & Travel
              </li>
            </div>

            {/* Three */}
            <div className="linkGroup">
              <span className="groupTitle">
                Others
              </span>

              <li className="footerList flex">
                <FiChevronRight className='icon'/> Blog
              </li>

              <li className="footerList flex">
                <FiChevronRight className='icon'/> Privacy Policy
              </li>

              <li className="footerList flex">
                <FiChevronRight className='icon'/> Terms & Conditions
              </li>

            </div>
          </div>

          <div className="footerDiv flex">
            <FaRegCopyright className='icon'/>  <small>copyright reserved Rusdi Barbershop</small>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Footer